jQuery_T4NT(document).ready(function($) {
  // any code js
  

function removeOptions(selectElement) {
   var i, L = selectElement.options.length - 1;
   for(i = L; i >= 0; i--) {
      if(i != 0) {
          selectElement.remove(i); 
        }
   }
}

removeOptions(document.getElementById('checkout_shipping_address_country'));

});